<!-- height here is to avoid the page flicker which is created during the change in position of the header -->
<div [ngStyle]="{ height: desktopHeaderHeight$ | async }">
  <div [ngClass]="headerClasses$ | async">
    <header data-testing-id="page-header" class="top" id="header">
      <!-- using @if instead of ngSwitch/ngIf to resolve hydration and duplicate headers -->
      <ng-container *ngIf="headerType$ | async as headerType; else defaultHeader">
        <ish-header-simple *ngIf="headerType === 'simple'" />
        <ish-header-error *ngIf="headerType === 'error'" />
        <ish-header-checkout *ngIf="headerType === 'checkout'" />
      </ng-container>

      <ng-template #defaultHeader>
        <custom-header-default
          [isSticky]="isSticky$ | async"
          [deviceType]="deviceType$ | async"
          [reset]="reset$ | async"
        />
      </ng-template>
    </header>
  </div>
</div>
